import { useUserStore } from "@/stores/user"
import { v4 as uuidv4 } from 'uuid'
import { Encrypter } from '../utils'

export type UseParamsOptions = {
  /** 是否携带 userid / tokens。public_config 必须传 false。 */
  includeAuth?: boolean
}

export function useParams() {
  const userStore = useUserStore()
  const getRequestParams = (
    data: Record<string, string | number>,
    options: UseParamsOptions = {}
  ) => {
    let uuid = userStore.getUuid
    if (!uuid) {
      uuid = uuidv4()
      userStore.setUuid(uuid)
    }
    const userInfo = userStore.getUserInfo
    const raw: Record<string, string | number> = {
      device: uuid,
      ...data
    }
    if (options.includeAuth !== false && userInfo.id && userInfo.token) {
      raw.userid = userInfo.id
      raw.tokens = userInfo.token
    }
    const params = Encrypter.createRequestParams(raw)
    const formData = new FormData()
    formData.append('sign_sign', params.sign_sign)
    formData.append('sign_data', params.sign_data)
    if (params.sign_curpage) {
      formData.append('sign_curpage', params.sign_curpage)
    }
    return formData
  }
  return getRequestParams
}
